import { mdiLayers, mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { MyMap } from "../Map/View/MyMap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import "./layersComponentStyle.css";

export default function LayersComponent2() {
  const [visible, setVisible] = useState(false);
  const [listData, setListData] = useState();
  const onClickSVG = (i) => {
    let bool = listData[i].get("isSvgOpen");
    if (!bool) {
      listData[i].set("isSvgOpen", true);
    } else {
      listData[i].set("isSvgOpen", false);
    }
    setListData([...listData]);
  };

  const onChangeLayerOpacity = (indexInfo, opacity) => {
    let ind = indexInfo?.ind;
    let subInd = indexInfo?.subInd;
    if (subInd != undefined) {
      listData[ind].getLayersArray()[subInd].set("opacity", opacity / 100);
    } else {
      listData[ind].set("opacity", opacity / 100);
    }
    setListData([...listData]);
  };

  const onClickEye = (layer, ind) => {
    let bool = listData[ind].get("visible");
    listData[ind].set("visible", !bool);
    setListData([...listData]);
  };
  const onClickSubEye = (layer, ind, subInd) => {
    let bool = listData[ind].getLayersArray()[subInd].get("visible");
    listData[ind].getLayersArray()[subInd].set("visible", !bool);
    setListData([...listData]);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    let currentIndex = source.index;
    let toIndex = destination.index;

    if (result.type == "droppableItem") {
      let layers = [...listData];
      let layer = layers[currentIndex];
      layers.splice(currentIndex, 1);
      layers.splice(toIndex, 0, layer);
      let length = layers.length;
      layers.forEach((layer, ind) => {
        layer.setZIndex(10 * (length - ind));
        let subLength = layer.getLayersArray().length;
        if (subLength > 1) {
          for (let j = 0; j < subLength; j++) {
            layer.getLayersArray()[j].setZIndex(10 * (length - ind) - j);
          }
        }
      });
      setListData(layers);
    } else if (result.type.includes("inner-")) {
      let index = parseInt(result.type.split("-")[1]);
      let layers = listData[index].getLayers().getArray();
      let layer = layers[currentIndex];
      layers.splice(currentIndex, 1);
      layers.splice(toIndex, 0, layer);
      layers.forEach((layer, ind) => {
        layer.setZIndex(listData[index].getZIndex() - ind);
      });
      console.log(layers);
      setListData([...listData]);
    }
  };

  const onClickSubLayer = (ind) => {
    console.log(ind);
    if (listData[ind].getLayersArray().length > 1) {
      let bool = listData[ind].get("isSubListOpen");
      listData[ind].set("isSubListOpen", !bool);
      setListData([...listData]);
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      let layers = MyMap.getLayers().getArray();
      layers.sort(function (a, b) {
        return b.getZIndex() - a.getZIndex();
      });
      setListData(layers);
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <button className="whiteBtn">
      <Icon path={mdiLayers} size={1.5} style={{ color: "black", cursor: "pointer" }} onClick={() => setVisible(!visible)} />
      {visible && (
        <div className="layerComponent2Body map-overlay-popup">
          <div className="row" style={{ background: "white", borderRadius: "8px", margin: "0px", height: "25px" }}>
            <div className="col-12" style={{ textAlign: "end" }}>
              <Icon onClick={() => setVisible(false)} path={mdiClose} size={1} style={{ color: "black", cursor: "pointer" }} />
            </div>
          </div>
          <div className="row" style={{ height: "calc(100% - 28px)" }}>
            <div className="col-12">
              <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
                <Droppable droppableId="droppable" type="droppableItem">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={{
                        background: snapshot.isDraggingOver ? "#aaaaaa" : "transparent",
                        height: "100%",
                      }}
                    >
                      {listData.map((layer, ind) => {
                        return (
                          <Draggable key={ind} draggableId={"parentDragable" + ind} index={ind}>
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={{
                                  userSelect: "none",
                                  margin: "0 0 2px 0",
                                  color: "black",
                                  backgroundColor: snapshot.isDragging ? "#888888" : ind % 2 == 0 ? "#dddddd" : "white",
                                  ...provided.draggableProps.style,
                                  fontSize: "small",
                                }}
                              >
                                <div className="row" style={{ height: "30px", paddingInline: "0px", margin: "0px" }}>
                                  <div
                                    {...provided.dragHandleProps}
                                    className="col-1"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      minWidth: "0px",
                                      padding: "0px",
                                      margin: "0px",
                                      color: "black",
                                    }}
                                    onClick={() => onClickSubLayer(ind)}
                                  >
                                    {layer.getLayersArray().length > 1 ? (
                                      layer.get("isSubListOpen") ? (
                                        <i className="fas fa-minus"></i>
                                      ) : (
                                        <i className="fas fa-plus"></i>
                                      )
                                    ) : (
                                      <i className="fas fa-grip-lines"></i>
                                    )}
                                  </div>
                                  <div className="col-9" style={{ minWidth: "0px", padding: "0px", margin: "0px", paddingInline: "4px", color: "black" }}>
                                    <label>
                                      <b>{layer.get("name")}</b>
                                    </label>
                                    <input
                                      type="range"
                                      className="form-control"
                                      max={100}
                                      min={0}
                                      onChange={(e) => onChangeLayerOpacity({ ind: ind }, e.target.value)}
                                      value={layer.get("opacity") * 100}
                                      style={{ height: "2px", padding: "1px", margin: "0px" }}
                                    />
                                  </div>
                                  <div
                                    className="col-1"
                                    onClick={() => onClickSVG(ind)}
                                    style={{ minWidth: "0px", fontSize: "small", padding: "0px", margin: "0px", display: "flex", alignItems: "center" }}
                                  >
                                    {layer.get("isSvg") && layer.get("isSvgOpen") === true ? (
                                      <label
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          justifyContent: "center",
                                          display: "flex",
                                          alignItems: "center",
                                          fontWeight: "bolder",
                                          fontSize: "large",
                                          color: "blue",
                                          cursor: "pointer",
                                        }}
                                      >
                                        L
                                      </label>
                                    ) : (
                                      <div style={{ width: "100%", height: "100%", position: "relative", cursor: "pointer" }}>
                                        <label
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            position: "absolute",
                                            justifyContent: "center",
                                            display: "flex",
                                            alignItems: "center",
                                            fontWeight: "bolder",
                                            fontSize: "large",
                                            color: "gray",
                                            cursor: "pointer",
                                          }}
                                        >
                                          L
                                        </label>
                                        <label className="line-label-45"></label>
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className="col-1"
                                    onClick={() => onClickEye(layer, ind)}
                                    style={{ minWidth: "0px", fontSize: "small", padding: "0px", margin: "0px", display: "flex", alignItems: "center" }}
                                  >
                                    {layer.get("visible") === true ? (
                                      <i className="fas fa-eye fa-lg" style={{ color: "blue" }}></i>
                                    ) : (
                                      <i className="fas fa-eye-slash fa-lg" style={{ color: "gray" }}></i>
                                    )}
                                  </div>
                                </div>
                                {layer.get("isSvgOpen") === true && <img alt="isSvgOpen" src={`data:image/svg+xml;utf8,${encodeURIComponent(layer.get("svg"))}`} />}
                                {layer.getLayersArray().length > 1 && layer.get("isSubListOpen") && (
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="row">
                                        <div className="col-12">
                                          <Droppable droppableId={`'${ind * 10 + 1}'`} type={"inner-" + ind} key={ind + 1}>
                                            {(provided2, snapshot2) => {
                                              return (
                                                <div
                                                  {...provided2.droppableProps}
                                                  ref={provided2.innerRef}
                                                  style={{
                                                    background: snapshot2.isDraggingOver ? "	#666666" : "	#E8E8E8",
                                                    paddingTop: "10px",
                                                    paddingBottom: "10px",
                                                    paddingLeft: "20px",
                                                  }}
                                                >
                                                  {layer
                                                    .getLayersArray()
                                                    .sort((a, b) => {
                                                      return b.getZIndex() - a.getZIndex();
                                                    })
                                                    .map((sublayer, subInd) => {
                                                      return (
                                                        <Draggable key={subInd} draggableId={`'${subInd}'`} index={subInd}>
                                                          {(provided, snapshot) => {
                                                            return (
                                                              <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                style={{
                                                                  userSelect: "none",
                                                                  margin: "0 0 2px 0",
                                                                  backgroundColor: snapshot.isDragging ? "#cccccc" : subInd % 2 == 1 ? "white" : "white",
                                                                  color: "black",
                                                                  fontSize: "small",
                                                                  ...provided.draggableProps.style,
                                                                }}
                                                              >
                                                                <div className="row" style={{ height: "30px", paddingInline: "0px", margin: "0px" }}>
                                                                  <div className="col-1" style={{ padding: "0px", margin: "0px" }}></div>
                                                                  <div
                                                                    {...provided.dragHandleProps}
                                                                    className="col-1"
                                                                    style={{
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                      justifyContent: "center",
                                                                      minWidth: "0px",
                                                                      color: "black",
                                                                      padding: "0px",
                                                                      margin: "0px",
                                                                    }}
                                                                  >
                                                                    <i className="fas fa-grip-lines"></i>
                                                                  </div>
                                                                  <div
                                                                    className="col-8"
                                                                    style={{ minWidth: "0px", padding: "0px", margin: "0px", paddingInline: "4px", color: "black" }}
                                                                  >
                                                                    <label className="test">{sublayer.get("name")}</label>
                                                                    <input
                                                                      type="range"
                                                                      className="form-control"
                                                                      max={100}
                                                                      min={0}
                                                                      onChange={(e) => onChangeLayerOpacity({ ind: ind, subInd: subInd }, e.target.value)}
                                                                      value={sublayer.get("opacity") * 100}
                                                                      style={{ height: "2px", padding: "1px", margin: "0px" }}
                                                                    />
                                                                  </div>
                                                                  <div className="col-1" style={{ padding: "0px", margin: "0px" }}></div>
                                                                  <div
                                                                    className="col-1"
                                                                    onClick={() => onClickSubEye(sublayer, ind, subInd)}
                                                                    style={{
                                                                      minWidth: "0px",
                                                                      fontSize: "small",
                                                                      padding: "0px",
                                                                      margin: "0px",
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                    }}
                                                                  >
                                                                    {sublayer.get("visible") === true ? (
                                                                      <i className="fas fa-eye fa-lg" style={{ color: "blue" }}></i>
                                                                    ) : (
                                                                      <i className="fas fa-eye-slash fa-lg" style={{ color: "gray" }}></i>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            );
                                                          }}
                                                        </Draggable>
                                                      );
                                                    })}
                                                </div>
                                              );
                                            }}
                                          </Droppable>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>
        </div>
      )}
    </button>
  );
}
